import React from 'react';
import _ from 'underscore';
import { Table } from 'react-bootstrap';
import moment from 'moment';
import { Link } from 'react-router-dom';

const UpcomingEvents = (props) => {
    var rows = [];
    var upcoming = props.events;

    if (!!upcoming === true && upcoming.length) {
        var limit = (upcoming.length <= 5) ? upcoming.length : 5;
        for (var i = 0; i < limit; i++) {
            var event = upcoming[i];
            var date = moment(event.startDateTime);
            rows.push(<tr key={'upcoming-event-' + i}>
                <td>
                    <Link to={"/events/?eventID=" + event.eventID}>
                        {event.title}
                    </Link>
                </td>
                <td>
                    <strong>{date.format('MMM. DD')}</strong>&nbsp;@&nbsp;<em>{(date.format('hh:mm a'))}</em>
                </td>
            </tr>);
        }
    } else {
        return (<div className="alert alert-info">
            <p>No Upcoming Events found for the next 7 days.</p>
        </div>);
    }

    return (<div>
        <Table responsive bordered striped condensed>
            <thead>
                <tr>
                    <td><strong>Event</strong></td>
                    <td><strong>Date</strong></td>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    </div>);
}

export default UpcomingEvents;